import { c as _c } from "react/compiler-runtime";
import type { ReactElement, ReactNode } from 'react';
type TRootFallbackProps = Readonly<{
  title: string;
  children: ReactNode;
}>;
export function RootFallback(t0) {
  const $ = _c(7);
  const {
    title,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      minHeight: "100dvh",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
      padding: "2rem",
      fontFamily: "system-ui, sans-serif",
      textAlign: "center"
    };
    t2 = {
      margin: 0,
      fontSize: "1.5rem",
      fontWeight: 600
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h1 style={t2}>{title}</h1>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <main style={t1}>{t3}{children}</main>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}